<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Header - Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{
          $t("account.title")
          }}
        </span>
        <h3 class="page-title">{{ $t("account.sub") }}</h3>
      </d-col>
    </d-row>
    <!-- Page Header - Title -->
    <d-col lg="8" class="mx-auto mt-4">
      <d-card class="card-small edit-user-details mb-4">
        <d-card-header class="p-0">
          <!-- User Details - Background -->
        </d-card-header>
        <d-card-body class="p-0">
          <!-- Nav Wrapper -->
          <d-form class="py-4">
            <d-form-row class="mx-4">
              <d-col lg="8">
                <d-form-row>
                  <!-- First Name -->
                  <d-col md="6" class="form-group">
                    <label for="firstName">{{ $t("account.firstname") }}</label>
                    <d-input type="text" id="firstName" v-model="account.first_name" />
                  </d-col>

                  <!-- Last Name -->
                  <d-col md="6" class="form-group">
                    <label for="lastName">{{ $t("account.lastname") }}</label>
                    <d-input type="text" id="lastName" v-model="account.last_name" />
                  </d-col>

                  <!-- Email Address -->
                  <d-col md="12" class="form-group">
                    <label for="emailAddress">{{ $t("account.email") }}</label>
                    <d-input-group seamless>
                      <d-input-group-text slot="prepend">
                        <i class="material-icons">&#xE0BE;</i>
                      </d-input-group-text>
                      <d-input id="emailAddress" v-model="account.email" />
                    </d-input-group>
                  </d-col>
                </d-form-row>
              </d-col>

              <!-- User Profile Picture -->
              <d-col lg="4">
                <label
                  for="userProfilePicture"
                  class="text-center w-100 mb-4"
                >{{ $t("account.profile") }}</label>
                <div class="edit-user-details__avatar m-auto">
                  <img src="@/assets/images/avatars/avatar.svg" alt="User Avatar" />
                  <label class="edit-user-details__avatar__change">
                    <i class="material-icons mr-1">&#xE439;</i>
                    <d-input type="file" id="userProfilePicture" class="d-none" />
                  </label>
                </div>
                <d-button size="sm" class="btn-white d-table mx-auto mt-4">
                  <i class="material-icons">&#xE2C3;</i>
                  {{ $t("account.upload") }}
                </d-button>
              </d-col>
            </d-form-row>

            <hr />

            <!-- Notifications 
            <d-form-row class="mx-4 py-2">
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">Notifications</d-form-text>
                <d-form-text
                  tag="p"
                  class="text-muted m-0"
                >Choose which email updates you want to receive</d-form-text>
              </d-col>
            </d-form-row>-->

            <!-- New Leads 
            <d-form-row class="mx-4">
              <d-col tag="label" for="conversationsEmailsToggle" class="col-form-label">
                When new leads are available
                <d-form-text
                  class="text-muted lgr"
                >Sends an update when more than 50 new leads are available.</d-form-text>
              </d-col>
              <d-col class="d-flex">
                <d-checkbox checked class="ml-auto my-auto" id="conversationsEmailsToggle" toggle />
              </d-col>
            </d-form-row>-->

            <!-- New Projects
            <d-form-row class="mx-4">
              <d-col tag="label" for="newProjectsEmailsToggle" class="col-form-label">
                Campaign updates
                <d-form-text
                  class="text-muted lgr"
                >Sends updates when your campaigns reach new records</d-form-text>
              </d-col>
              <d-col class="d-flex">
                <d-checkbox class="ml-auto my-auto" id="newProjectsEmailsToggle" toggle />
              </d-col>
            </d-form-row>-->

            <!-- New Spring Features -->
            <!-- <d-form-row class="mx-4">
              <d-col tag="label" for="vulnerabilitiesEmailsToggle" class="col-form-label">
                Spring feature updates
                <d-form-text class="text-muted lgr">Get the latest update on new Spring features.</d-form-text>
              </d-col>
              <d-col class="d-flex">
                <d-checkbox
                  checked
                  class="ml-auto my-auto"
                  id="vulnerabilitiesEmailsToggle"
                  toggle
                />
              </d-col>
            </d-form-row>-->

            <!-- Change Password -->
            <d-form-row class="mx-4 py-2">
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("account.changepassword")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0">
                  {{
                  $t("account.changepasswordsub")
                  }}
                </d-form-text>
              </d-col>
            </d-form-row>

            <d-form-row class="mx-4 py-2">
              <!-- Old Password -->
              <d-col md="4" class="form-group">
                <label for="oldPassword">{{ $t("account.oldpassword") }}</label>
                <d-input id="oldPassword" placeholder="Old Password" />
              </d-col>

              <!-- New Password -->
              <d-col md="4" class="form-group">
                <label for="newPassword">{{ $t("account.newpassword") }}</label>
                <d-input id="newPassword" placeholder="New Password" />
              </d-col>

              <!-- Repeat New Password -->
              <d-col md="4" class="form-group">
                <label for="repeatNewPassword">
                  {{
                  $t("account.repeatpassword")
                  }}
                </label>
                <d-input id="repeatNewPassword" placeholder="Repeat Password" />
              </d-col>
            </d-form-row>

            <hr />
            <!-- Danger Area -->
            <d-form-row class="mx-4 py-2">
              <d-col class="mb-3">
                <d-form-text tag="h6" class="m-0 font-weight-bold">
                  {{
                  $t("account.danger")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0">
                  {{
                  $t("account.dangersub")
                  }}
                </d-form-text>
                <d-btn
                  @click.native="handleDeleteAccount"
                  class="btn btn-sm text-white btn-danger d-table mr-3 mt-4 font-weight-bold"
                >{{ $t("account.delete") }}</d-btn>
              </d-col>
            </d-form-row>
          </d-form>
        </d-card-body>
        <!-- Save Changes -->
        <d-card-footer class="border-top">
          <d-btn
            @click.native="handleSave"
            class="btn-accent ml-auto d-table float-right mr-3"
          >{{ $t("account.save") }}</d-btn>
        </d-card-footer>
      </d-card>
    </d-col>

    <!-- Delete Account Modal -->
    <d-modal v-if="showDelete" @close="handleClose">
      <d-modal-header>
        <d-modal-title>{{ $t("account.deletemodal.title") }}</d-modal-title>
      </d-modal-header>
      <d-modal-body class="pb-0 mb-0">
        {{ $t("account.deletemodal.text1") }}
        <br />
        {{ $t("account.deletemodal.text2") }}
      </d-modal-body>
      <d-modal-body>
        <d-btn class="cursor btn-danger">{{ $t("account.delete") }}</d-btn>
      </d-modal-body>
    </d-modal>
    <!-- Save Settings Modal -->
    <d-modal v-if="showSave" @close="handleClose">
      <d-modal-header>
        <d-modal-title>{{ $t("account.savemodal.text1") }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>{{ $t("account.savemodal.text2") }}</d-modal-body>
    </d-modal>
  </d-container>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  mounted() {
    if (this.getCurrentUser) {
      this.account = _.cloneDeep(this.getCurrentUser);
    }
  },
  data() {
    return {
      showDelete: false,
      showSave: false,
      account: {}
    };
  },
  methods: {
    handleDeleteAccount() {
      this.showDelete = true;
    },
    handleSave() {
      this.showSave = true;
    },
    handleClose() {
      this.showSave = false;
      this.showDelete = false;
    }
  }
};
</script>
<style>
.lgr {
  font-size: 12px !important;
}
</style>
